import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { Colors } from 'constants/colors'
import React from 'react'

interface SideDrawerLinkProps {
  text: string
  icon: JSX.Element
  open: boolean
  onClick?: React.MouseEventHandler<HTMLLIElement>
  path: string
}

export default function SideDrawerLink({
  open,
  text,
  icon,
  onClick,
  path,
}: SideDrawerLinkProps): JSX.Element {
  const pathname = window.location.pathname
  return (
    <ListItem disablePadding sx={{ display: 'block' }} onClick={onClick}>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: open ? 'initial' : 'center',
          px: 2.5,
          color: Colors.darkCoolGray,
        }}
        selected={pathname.split('/')[1] === path}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 1.5 : 'auto',
            justifyContent: 'center',
            color: Colors.white,
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
      </ListItemButton>
    </ListItem>
  )
}
